/**
 * 인증 후 이동할 경로(`next` 쿼리)를 검증한다. 검증 없이 redirect(next)를 하면
 * `?next=https://evil.example`로 로그인 직후 외부 사이트로 보내는 오픈 리다이렉트
 * 취약점이 된다 — 같은 사이트 안의 절대 경로("/..."), 그것도 "//"(프로토콜 상대 URL)와
 * "/\"(일부 브라우저가 "//"로 해석)로 시작하지 않는 것만 허용한다.
 */
export function safeNextPath(next: string | null | undefined): string {
  if (!next) return "/";
  if (!next.startsWith("/")) return "/";
  if (next.startsWith("//") || next.startsWith("/\\")) return "/";
  return next;
}

// 비밀번호 재설정 화면은 재설정 메일 링크로 들어온 경우에만 열어준다. 링크 검증에 성공하면
// /auth/confirm이 브라우저(sessionStorage)에 표시를 잠깐 남기고, 화면이 그걸 확인한다.
// 로그인만 돼 있는 사용자가 주소를 직접 입력해 들어오는 걸 막는 UX용 문지기다 — 서버가 쿠키를
// 못 심는 SPA라서 예전의 httpOnly 쿠키보다는 약하다. 비밀번호 변경 자체의 보안은 Supabase 세션과
// (필요하면) 현재 비밀번호 재확인이 맡는다.
export const PASSWORD_RESET_PATH = "/auth/update-password";
const PASSWORD_RESET_KEY = "dabar:pw-reset";
const PASSWORD_RESET_MAX_AGE_MS = 10 * 60 * 1000;

export const passwordResetGate = {
  open() {
    try {
      sessionStorage.setItem(PASSWORD_RESET_KEY, String(Date.now()));
    } catch {
      /* 저장이 막힌 브라우저면 화면이 열리지 않는다 — 메일 링크를 다시 누르면 같은 결과라 감수 */
    }
  },
  isOpen(): boolean {
    try {
      const at = Number(sessionStorage.getItem(PASSWORD_RESET_KEY));
      return Number.isFinite(at) && at > 0 && Date.now() - at < PASSWORD_RESET_MAX_AGE_MS;
    } catch {
      return false;
    }
  },
  close() {
    try {
      sessionStorage.removeItem(PASSWORD_RESET_KEY);
    } catch {
      /* 무시 */
    }
  },
};
